<template>
	<v-col cols="12" v-if="permisoVista('usuarios', 'r')">
		<bar-code-reader
			v-if="dialogRFID"
			@change="leerRFID"
		></bar-code-reader>
		<v-dialog v-model="dialogDelete" persistent max-width="40%">
			<v-card>
				<v-card-text>
					<p class="text-h5 pt-4 font-weight-regular text--primary">
						¿Está seguro que desea eliminar este Usuario?
					</p>
					<p class="subtitle-1">
						Esta acción no se puede revertir y será permanente.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						:disabled="deleting"
						@click="cerrarDialogDelete()"
						>Cancelar</v-btn
					>
					<v-btn
						text
						color="error"
						:disabled="deleting"
						:loading="deleting"
						@click="eliminarUsuario()"
						>Eliminar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- ======= Modal: Probar Notificación Telegram (versión pulida) ======= -->
		<v-dialog v-model="dialogTelegram" persistent max-width="760px">
		<v-card class="elevate rounded-xl">
			<!-- Header -->
			<div class="py-4 px-6 pr-6">
				<div class="d-flex align-center justify-space-between w-100">
					<div class="d-flex align-center min-w-0">
						<v-avatar size="40" class="mr-3" style="background: rgba(34,158,217,.12);">
							<svg viewBox="0 0 240 240" class="tg-svg" aria-label="Telegram">
								<defs>
								<linearGradient id="tgGrad" x1="0" y1="0" x2="0" y2="1">
									<stop offset="0%"  stop-color="#37AEE2"/>
									<stop offset="100%" stop-color="#1E96C8"/>
								</linearGradient>
								</defs>
								<circle cx="120" cy="120" r="120" fill="url(#tgGrad)"/>
								<path fill="#FFFFFF" d="M176 70c6 2-1 33-8 69c-5 23-16 25-33 15l-22-14l-11 11c-1 1-3 2-4 1l2-24l53-48c3-3-1-4-4-2l-66 41l-25-8c-7-2-7-7 1-10l113-43c4-2 7-1 9 2z"/>
							</svg>
						</v-avatar>

						<div class="min-w-0">
							<div class="text-subtitle-1 font-weight-bold truncate">Probar notificación de Telegram</div>
							<div class="caption grey--text truncate">
							{{ telegramTarget.nombre || 'N/D' }}
							<span v-if="telegramTarget.email"> • {{ telegramTarget.email }}</span>
							</div>
						</div>
					</div>

					<v-chip
					label small class="status-chip"
					:class="telegramTarget.enLinea ? 'chip-online' : 'chip-offline'"
					>
					{{ telegramTarget.enLinea ? 'Usuario en línea' : 'Usuario desconectado' }}
					</v-chip>
				</div>
			</div>

			<v-divider></v-divider>

			<!-- Body -->
			<div class="pt-4 pb-0 px-6">
			<!-- Última prueba -->
			<v-sheet v-if="telegramTarget.ultimoEnvio"
					class="pa-3 mb-4 rounded-lg border-light">
				<div class="d-flex align-start">
				<v-icon class="mr-2" small>mdi-information</v-icon>
				<div>
					<div class="body-2">
					Última notificación de prueba:
					<strong>{{ formatDateTime(telegramTarget.ultimoEnvio) }}</strong>
					</div>
					<div v-if="telegramTarget.ultimoMensaje" class="mt-1 caption grey--text text--darken-1">
					Mensaje anterior:
					<div class="mt-1 font-italic text--primary wrap-quotes">
						“{{ telegramTarget.ultimoMensaje }}”
					</div>
					</div>
				</div>
				</div>
			</v-sheet>

			<!-- Mensaje -->
			<v-textarea
				v-model="telegramTarget.mensaje"
				label="Mensaje de prueba"
				auto-grow
				outlined
				:counter="250"
				:maxlength="250"
				rows="3"
				class="mb-2"
			/>

			<!-- Prioridad (100% ancho y centrado) -->
			<v-row no-gutters class="mt-1" justify="center">
			<v-col cols="12" class="d-flex justify-center">
				<v-btn-toggle
				v-model="telegramTarget.prioridad"
				dense
				mandatory
				class="priority-toggle mx-auto"
				>
				<v-btn
					:value="false"
					depressed
					class="priority-btn"
					:class="{'primary white--text': !telegramTarget.prioridad}"
				>
					<v-icon left>mdi-bell</v-icon>
					Normal
				</v-btn>

				<v-btn
					:value="true"
					depressed
					class="priority-btn"
					:class="{'red darken-1 white--text': telegramTarget.prioridad}"
				>
					<v-icon left>mdi-bell-alert</v-icon>
					Alta prioridad
				</v-btn>
				</v-btn-toggle>
			</v-col>
			</v-row>

			<!-- Errores -->
			<ul v-if="erroresTelegram.length" class="mb-0 mt-2">
				<li v-for="(e, i) in erroresTelegram"
					:key="'telerr'+i"
					class="red--text body-2">
				{{ e }}
				</li>
			</ul>
		</div>

			<!-- Footer -->
			<v-card-actions class="px-6 py-4">
			<v-btn text color="blue"
					:disabled="testingTelegram"
					@click="refrescarEstadoTelegram()">
				<v-icon left>mdi-refresh</v-icon>
				Actualizar estado
			</v-btn>

			<v-spacer></v-spacer>

			<v-btn text color="grey darken-1"
					:disabled="testingTelegram"
					@click="cerrarDialogTelegram()">
				Cancelar
			</v-btn>

			<v-btn color="primary" class="elevate"
					dark :loading="testingTelegram"
					:disabled="testingTelegram"
					@click="enviarNotificacionTelegram()">
				<v-icon left>mdi-send</v-icon>
				Enviar prueba
				<template v-slot:loader>
				<v-progress-circular
					indeterminate
					:width="2"
					:size="22"
				/>
				</template>
			</v-btn>
			</v-card-actions>
		</v-card>
		<v-snackbar v-model="snackTel.show" :color="snackTel.color" timeout="2500" top>
			{{ snackTel.text }}
		</v-snackbar>
		</v-dialog>
	<v-dialog v-model="dialogResetPassword" persistent max-width="40%">
			<v-card>
				<v-card-text>
					<p class="text-h5 pt-4 font-weight-regular text--primary">
						¿Está seguro que deseas reestablecer la contraseña?
					</p>
					<p class="subtitle-1">
						Usuario: {{editedItem.nombre}} <br>
						Email: {{editedItem.email}}
						<br>
						Esta acción no se podrá revertir.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						:disabled="deleting"
						@click="dialogResetPassword = false"
						>Cancelar</v-btn
					>
					<v-btn
						text
						color="error"
						:disabled="deleting"
						:loading="deleting"
						@click="resetPassword()"
						>Sí, restablecer</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogUnloackAccount" persistent max-width="40%">
			<v-card>
				<v-card-text>
					<p class="text-h5 pt-4 font-weight-regular text--primary">
						¿Está seguro que deseas desbloquear la cuenta?
					</p>
					<p class="subtitle-1">
						Usuario: {{editedItem.nombre}} <br>
						Email: {{editedItem.email}}
						<br>
						Esta acción no se podrá revertir.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						:disabled="deleting"
						@click="dialogUnloackAccount = false"
						>Cancelar</v-btn
					>
					<v-btn
						text
						color="error"
						:disabled="deleting"
						:loading="deleting"
						@click="UnlockAccount()"
						>Sí, desbloquear</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="pin" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <p class="mb-0 text-h6">Asignar PIN a {{pinViewed.nombre}}</p>
            </v-card-title>
            <v-card-text>
              <br>
              <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                <v-text-field
                  v-if="pinType == 'numbers'"
                  v-model="pinViewed.pin"
                  :maxlength="pinLength"
                  type="number"
                  label="PIN"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-if="pinType == 'chars'"
                  v-model="pinViewed.pin"
                  :maxlength="pinLength"
                  label="PIN"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 text-center justify-center">
                <v-btn
                  color="blue"
                  @click="sugerirPin()"
                  large
                >
                  <v-icon color="white" x-large>mdi-reload</v-icon> Sugerir PIN
                </v-btn>
              </v-col>
              <ul>
                <li v-for="(error,idx) in errores" :key="'error'+idx" class="red--text">{{error}}</li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn 
					color="green" 
					text 
					@click="
						pin=false; 
						pinViewed=Object.assign({},defaultPinViewed);
						errores = [];
					"
					>Cancelar</v-btn
				>
                <v-btn color="red" text @click="savePINRFID()" :disabled="saving" :loading="saving">
                  Guardar
                  <template v-slot:loader>
                    <v-progress-circular
                      indeterminate
                      :width="2"
                      :size="24"
                      color="red"
                    ></v-progress-circular>
                  </template>
                </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogRFID" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <p class="mb-0 text-h6">Asignar RFID a {{pinViewed.nombre}}</p>
            </v-card-title>
            <v-card-text>
              <br>
              <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 text-center" >
                <p class="text-h5">Acerque la tarjeta RFID</p>
                <v-progress-circular
                  :rotate="-90"
                  :size="150"
                  :width="15"
                  :value="percentRFID"
                  color="primary"
                >
                  {{ percentRFID }}%
                </v-progress-circular>
              </v-col>
              <br>
              <ul>
                <li v-for="(error,idx) in errores" :key="'error'+idx" class="red--text">{{error}}</li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn 
                  color="green" 
                  text 
                  @click="
                    dialogRFID=false;
                    rfidsLeidos = [];
                    percentRFID = 0;
                    errores = [];
                    pinViewed=Object.assign({},defaultPinViewed);
                  "
                  >Cancelar</v-btn
                >
                <v-btn color="red" text :disabled="savingRFID || percentRFID < 100 || saving" @click="saveRFID"  :loading="saving">
                  Guardar
                  <template v-slot:loader>
                    <v-progress-circular
                      indeterminate
                      :width="2"
                      :size="24"
                      color="red"
                    ></v-progress-circular>
                  </template>
                </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
		<v-data-table
			:headers="headers"
			:items="usuarios"
			:search="search"
			:loading="loading"
			:key="loadingChange"
			loading-text="Cargando... Espere, Por Favor."
		>
			<template v-slot:[`item.validado`]="{ item }">
				<v-icon
					medium
					color="green"
					v-if="item.validado"
				>
					mdi-check-circle
				</v-icon>
			</template>
			<template v-slot:[`item.nombre`]="{ item }">
				<p class="py-1 my-1">{{ getNombre(item) }}</p>
			</template>
			<template v-slot:[`item.condicion`]="{ item }">
				<v-switch
					v-if="permisoVista('usuarios', 'd')"
					class="justify-center"
					@change="changeState(item)"
					:input-value="item.condicion"
					:label="item.condicion ? 'Activado' : 'Desactivado'"
				>
				</v-switch>
			</template>
			<template v-slot:item.bloqueo="{ item }">
				<v-icon
					medium
					color="red"
					v-if="item.bloqueado"
				>
					mdi-close-circle
				</v-icon>
				<v-icon
					medium
					color="green"
					v-else
				>
					mdi-check-circle
				</v-icon>
				<!-- ***** -->
				
			</template>
			<template v-slot:top>
				<v-toolbar flat color="white">
					<v-dialog
						v-model="dialog"
						persistent
						max-width="500px"
						:key="dialog"
					>
						<template v-slot:activator="{ on }">
							<v-btn
								v-if="permisoVista('usuarios', 'c')"
								color="primary"
								dark
								class="mb-2"
								v-on="on"
								>Nuevo Usuario</v-btn
							>
						</template>
						<v-card>
							<v-card-title>
								<span class="headline">{{ formTitle }}</span>
							</v-card-title>
							<v-card-text>
								<v-container>
									<v-row>
										<v-col class="d-flex" cols="11" sm="11">
											<v-select
												v-model="editedItem.idRol"
												:items="roles"
												label="Rol"
												item-text="nombre"
												:disabled="loadingRoles"
												item-value="idRol"
											></v-select>
										</v-col>
										<v-icon
											class="mr-2"
											:disabled="loadingRoles"
											@click="getRoles()"
										>
											mdi-reload
										</v-icon>
										<v-col class="d-flex" cols="11" sm="11">
											<v-select
												v-model="editedItem.idsTurnos"
												:items="turnos"
												label="Turno(s)"
												item-text="nombre"
												:disabled="loadingTurnos"
												item-value="idTurno"
												multiple
												chips
											></v-select>
										</v-col>
										<v-icon
											class="mr-2"
											:disabled="loadingRoles"
											@click="getTurnos()"
										>
											mdi-reload
										</v-icon>

										<v-col class="d-flex" cols="11" sm="11">
											<v-select
												v-model="
													editedItem.idsComercialLineas
												"
												:items="lineas"
												label="Líneas Comerciales"
												item-text="nombre"
												:disabled="loadingLineas"
												item-value="idComercialLinea"
												multiple
												chips
											></v-select>
										</v-col>
										<v-icon
											class="mr-2"
											:disabled="loadingLineas"
											@click="getComercialLineas()"
										>
											mdi-reload
										</v-icon>

										<v-col cols="12">
											<v-autocomplete
												v-model="editedItem.idPersona"
												:items="
													editedItem.idUsuario == null
														? personasMantenimiento
														: personasMantenimientoFiltred
												"
												item-value="idPersona"
												:item-text="nombrePersona"
												label="[Opcional] Asociar Persona"
												clearable
												@change="$set(editedItem,'nombre','')"
											></v-autocomplete>
										</v-col>

										<v-col
											justify="center"
											cols="12"
											sm="12"
											md="12"
										>
											<v-text-field
												v-model="editedItem.nombre"
												label="Nombre"
												:disabled="editedItem.idPersona!=null"
											></v-text-field>
										</v-col>
										<v-col
											justify="center"
											cols="6"
											sm="6"
											md="6"
										>
											<v-text-field
												:readonly="editedIndex >= 0"
												v-model="editedItem.email"
												label="Email"
											></v-text-field>
										</v-col>
										<v-col
											justify="center"
											cols="6"
											sm="6"
											md="6"
										>
											<v-text-field
												v-if="editedIndex < 0"
												v-model="editedItem.password"
												:append-icon="
													password
														? 'mdi-eye'
														: 'mdi-eye-off'
												"
												:type="
													password
														? 'text'
														: 'password'
												"
												name="password"
												label="Contraseña del Usuario"
												hint="Al menos 8 caracteres"
												counter
												@click:append="
													password = !password
												"
											></v-text-field>
										</v-col>
										<v-col
											justify="center"
											cols="12"
											sm="6"
											md="6"
										>
											<v-text-field
												v-model="editedItem.telefono"
												label="Telefono"
											></v-text-field>
										</v-col>
										<v-col
											justify="center"
											cols="12"
											sm="12"
											md="12"
										>
											<v-checkbox
												v-model="editedItem.dobleFactor"
												label="Autentificación de Doble Factor"
											></v-checkbox>
										</v-col>
									</v-row>
									<ul>
										<li
											class="red--text"
											v-for="ex in errores"
											:key="ex"
										>
											{{ ex }}
										</li>
									</ul>
								</v-container>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									color="blue darken-1"
									text
									@click="cerrarDialog"
									>Cancelar</v-btn
								>
								<v-btn
									color="red darken-1"
									text
									@click="save()"
									:disabled="saving"
									:loading="saving"
								>
									Guardar
									<template v-slot:loader>
										<v-progress-circular
											indeterminate
											:width="2"
											:size="24"
											color="red"
										></v-progress-circular>
									</template>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<v-spacer></v-spacer>
					<v-text-field
						v-model="search"
						append-icon="search"
						label="Buscar"
						single-line
						hide-details
					></v-text-field>
				</v-toolbar>
			</template>
			<template v-slot:[`item.action`]="{ item }">
				<v-tooltip
					
					bottom
					color="black"
					class="white--text"
				>
					<template v-slot:activator="{ on }">
						<v-icon
							v-on="on"
							v-if="permisoVista('usuarios', 'u')"
							small
							class="mr-1"
							@click="editItem(item)"
						>
							edit
						</v-icon>
					</template>
					<span class="white--text">Editar</span>
				</v-tooltip>
				<v-tooltip v-if="permisoVista('usuarios', 'u')"  bottom color="black" class="white--text">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on"
							v-if="rfid"
							small
							class="mr-1"
							@click="rfidView(item)"
						>
							mdi-credit-card
						</v-icon>
					</template>
					<span class="white--text">Asignar RFID</span>
				</v-tooltip>
				<v-tooltip v-if="permisoVista('usuarios', 'u')"  bottom color="black" class="white--text">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on"
							v-if="!rfid"
							small
							class="mr-1"
							@click="pinView(item)"
						>
							mdi-key
						</v-icon>
					</template>
					<span class="white--text">Asignar PIN</span>
				</v-tooltip>
				<v-tooltip v-if="permisoVista('usuarios', 'd')"  bottom color="black" class="white--text">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on"
							small
							class="mr-1"
							@click="showDialogDelete(item)"
						>
							mdi-delete
						</v-icon>
					</template>
					<span class="white--text">Eliminar</span>
				</v-tooltip>
				<v-tooltip v-if="permisoVista('usuarios', 'u')"  bottom color="black" class="white--text">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on"
							small
							class="mr-1"
							@click="showDialogResetPassword(item)"
						>
							mdi-lock-reset
						</v-icon>
					</template>
					<span class="white--text">Restablecer contraseña</span>
				</v-tooltip>
				<v-tooltip v-if="permisoVista('usuarios', 'u')"  bottom color="black" class="white--text">
					<template v-slot:activator="{ on }">
						<!-- <v-icon v-if="!item.bloqueado" small class="mr-1">
							mdi-lock-open-variant
						</v-icon> -->
						<v-icon v-on="on" v-if="item.bloqueado"
							small
							class="mr-1"
							@click="showDialogUnlockAccount(item)"
						>
						mdi-lock
						</v-icon>
					</template>
					<span class="white--text">Desbloquear cuenta</span>
				</v-tooltip>
				<!-- Probar Telegram -->
				<v-tooltip v-if="permisoVista('usuarios','u')" bottom color="black" class="white--text">
				<template v-slot:activator="{ on }">
					<v-icon
					v-on="on"
					small
					class="mr-1"
					@click="abrirDialogTelegram(item)"
					>
					mdi-send-circle-outline
					</v-icon>
				</template>
				<span class="white--text">Probar Telegram</span>
				</v-tooltip>
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="initialize">Refrescar</v-btn>
			</template>
		</v-data-table>
		<v-snackbar v-model="alerta" top color="error">
			Existe un Usuario con el mismo Email
			<v-btn text @click="alerta = false"> Cerrar </v-btn>
		</v-snackbar>
	</v-col>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex';

export default {
	data: () => ({
		snackTel: { show: false, text: '', color: 'success' },
		dialogTelegram: false,
		testingTelegram: false,
		erroresTelegram: [],
		telegramTarget: {
			idUsuario: null,
			nombre: '',
			email: '',
			enLinea: false,
			ultimoEnvio: null,
			ultimoMensaje: '',
			mensaje: '🔔 Prueba de notificación: todo OK.',
			prioridad: false
		},
		personas: [],
		personasMantenimiento: [],
		personasMantenimientoFiltred: [],
		dialogResetPassword : false,
		dialogUnloackAccount: false,
		deleting: false,
		dialogDelete: false,
		savingRFID: false,
		rfidsLeidos: [],
      	percentRFID: 0,
      	pin:false,
		dialogRFID: false,
		saving: false,
		password: true,
		loadingChange: false,
		roles: [],
		loadingRoles: false,
		dialog: false,
		alerta: false,
		search: "",
		headers: [
			{
				align: "center",
				sortable: false,
				value: "validado",
			},
			{
				text: "Nombre",
				align: "left",
				sortable: true,
				value: "nombre",
			},
			{
				text: "Email",
				align: "left",
				sortable: true,
				value: "email",
			},
			{
				text: "Rol",
				align: "left",
				sortable: true,
				value: "rol",
			},
			{
				text: "Activo",
				align: "center",
				sortable: true,
				value: "condicion",
			},
			{
				text: "Bloqueo",
				align: "center",
				sortable: true,
				value: "bloqueo",
			},
			{
				text: "Acciones",
				value: "action",
				sortable: false,
				align: "center",
			},
		],
		defaultPinViewed: {
			idPersona: 0,
			pin:'',
		},
		pinViewed:{
			idPersona: 0,
			pin:'',
		},
		loading: false,
		usuarios: [],
		action: 0,
		errores: [],
		editedIndex: -1,
		editedItem: {
			idUsuario: null,
			idPersona: null,
			telefono : null,
			idRol: -1,
			nombre: "",
			email: "",
			password: "",
			dobleFactor: false,
			idsTurnos: [],
			idsComercialLineas: [],
		},
		defaultItem: {
			idUsuario: null,
			idPersona: null,
			telefono : null,
			idRol: -1,
			nombre: "",
			email: "",
			password: "",
			dobleFactor: false,
			idsTurnos: [],
			idsComercialLineas: [],
		},
		turnos: [],
		loadingTurnos: false,
		lineas: [],
		loadingLineas: false,
	}),

	computed: {
      	...mapState(["pinType","pinLength","rfid"]),
		formTitle() {
			return this.editedIndex === -1 ? "Nuevo Usuario" : "Editar Usuario";
		},
	},

	watch: {
		dialog(val) {
			val || this.close();
		},
	},

	created() {
		this.initialize();
	},

	methods: {
		abrirDialogTelegram(item) {
			// Prepara el objetivo con datos del renglón
			this.telegramTarget = {
				idUsuario: item.idUsuario,
				nombre: this.getNombre(item),
				email: item.email || '',
				enLinea: false,
				ultimoEnvio: null,
				ultimoMensaje: '',
				mensaje: `🔔 Prueba de notificación para ${this.getNombre(item)}.`,
				prioridad: false,
				chatId: ''
			};
			this.erroresTelegram = [];
			this.dialogTelegram = true;

			// Cargar estado inicial (no bloquea apertura)
			this.refrescarEstadoTelegram();
		},

		cerrarDialogTelegram() {
			this.dialogTelegram = false;
			this.testingTelegram = false;
			this.erroresTelegram = [];
		},

		async refrescarEstadoTelegram() {
			this.erroresTelegram = [];
			try {
				// 1) ¿Está en línea?
				// Backend sugerido: GET /Usuarios/Online/{idUsuario} -> { enLinea: boolean }
				const online = await axios.get(`/Usuarios/Online/${this.telegramTarget.idUsuario}`);
				this.telegramTarget.enLinea = !!(online.data && online.data.enLinea);

				// 2) Última notificación de prueba
				// Backend sugerido: GET /Notificaciones/Telegram/Ultima/{idUsuario}
				// -> { fecha: '2025-10-18T12:34:56Z', mensaje: '...' } o 204 sin contenido
				const ultima = await axios.get(`/Notificaciones/TelegramUltima/${this.telegramTarget.idUsuario}`)
				.catch(err => {
					if (err.response && err.response.status === 204) return { data: null };
					throw err;
				});

				if (ultima.data) {
				this.telegramTarget.ultimoEnvio = ultima.data.fecha || null;
				this.telegramTarget.ultimoMensaje = ultima.data.mensaje || '';
				} else {
				this.telegramTarget.ultimoEnvio = null;
				this.telegramTarget.ultimoMensaje = '';
				}
			} catch (e) {
				console.log(e);
				this.erroresTelegram.push('No fue posible actualizar el estado. Intente nuevamente.');
			}
		},

		async enviarNotificacionTelegram() {
			this.erroresTelegram = [];
			if (!this.telegramTarget.idUsuario) { this.erroresTelegram.push('Falta el Id de usuario.'); return; }
			if (!this.telegramTarget.mensaje || this.telegramTarget.mensaje.trim().length < 3) {
				this.erroresTelegram.push('El mensaje es muy corto.'); return;
			}

			const mensaje = this.telegramTarget.prioridad ? `⚠️ ${this.telegramTarget.mensaje}` : this.telegramTarget.mensaje;

			this.testingTelegram = true;
			try {
				await axios.post('/Notificaciones/TelegramProbar', {
				idUsuario: this.telegramTarget.idUsuario,
				mensaje,
				prioridad: !!this.telegramTarget.prioridad,
				});

				this.testingTelegram = false;

				// Refresca la “última” y muestra feedback
				this.telegramTarget.ultimoEnvio = new Date().toISOString();
				this.telegramTarget.ultimoMensaje = mensaje;

				this.snackTel = {
				show: true,
				text: this.telegramTarget.prioridad ? 'Enviado con ALTA prioridad.' : 'Notificación enviada.',
				color: 'success'
				};
			} catch (e) {
				console.log(e);
				this.testingTelegram = false;
				let msg = 'Ocurrió un error al enviar la notificación.';
				if (e.response?.status === 404) msg = 'No se encontró el chat de Telegram para este usuario.';
				else if (e.response?.status === 409) msg = 'Conflicto al enviar la notificación. Intenta de nuevo.';

				this.snackTel = { show: true, text: this.telegramTarget.prioridad ? 'Enviado con ALTA prioridad.' : 'Notificación enviada.', color: 'success' };
				// Cerrar tras un pequeño delay
				setTimeout(() => { this.dialogTelegram = false; }, 600);
			}
		},
		formatDateTime(val) {
			try {
				if (!val) return '-';
				const d = new Date(val);
				// Formato local sencillo
				return d.toLocaleString();
			} catch {
				return val;
			}
		},
		getNombre(item){
			if(!item.nombre){
				const result = this.personas.find( persona => persona.idPersona == item.idPersona );
				return result ? this.nombrePersona(result) : 'N/D';
			}
			return item.nombre
		},
		nombrePersona: ({ nombre, paterno, materno }) =>
			`${nombre ? `${nombre} ` : ""}${paterno ? `${paterno} ` : ""}${
				materno ? `${materno} ` : ""
			}`.trim(),
		cerrarDialog(){
			this.dialog = false;
			this.$nextTick(() => {
				this.errores = [];
				this.personasMantenimientoFiltred = [];
			});
		},
		showDialogResetPassword(item){
			this.editedItem = { ...item };
			this.dialogResetPassword = true;
		},
		showDialogUnlockAccount(item){
			this.editedItem = { ...item };
			this.dialogUnloackAccount = true;
		},
		showDialogDelete(item){
			this.editedItem = { ...item };
			this.dialogDelete = true;
		},
		cerrarDialogDelete(){
			this.dialogDelete = false;
			this.editedItem = { ...this.defaultItem };
		},
		eliminarUsuario(){
			this.deleting = true;
			axios
				.put(`/Usuarios/Eliminar/${this.editedItem.idUsuario}`)
				.then( () => {
					this.deleting = false;
					this.cerrarDialogDelete();
					this.initialize();
				})
				.catch( error => {
					this.deleting = false;
					console.log(error);
				})
		},
		validatePINRFID(){
			this.errores = [];
			if(this.pinViewed.pin.length != this.pinLength){
				this.errores.push(`El Pin debe de ser de ${this.pinLength} Dígitos`);
			}
			if(!this.rfid){
				var reg = /^\d+$/;
				if(!reg.test(this.pinViewed.pin)){
					this.errores.push("El Pin debe de estar formado solo por Números");
				}
			}

			return this.errores.length == 0;
		},
		savePINRFID(){
			if(!this.validatePINRFID()) return;
			this.saving = true;

			axios
				.put(`/Usuarios/Actualizar/${this.pinViewed.idUsuario}`,{
					idRol: this.pinViewed.idRol,
					nombre: this.pinViewed.nombre,
					dobleFactor: this.pinViewed.dobleFactor,
					idsTurnos: this.pinViewed.idsTurnos,
					idsComercialLineas: this.pinViewed.idsComercialLineas,
					pin: this.pinViewed.pin,
					telefono: this.pinViewed.telefono,
				})
				.then( () => {
					this.saving = false;
					this.pin = false;
					this.dialogRFID = false;
					this.rfidsLeidos = [];
					this.percentRFID = 0;
					this.errores = [];
					this.pinViewed=Object.assign({}, this.defaultPinViewed);
				})
				.catch( error => {
					this.saving = false;
					if(error.response.status == 409){
						this.errores.push("Este PIN esta siendo usado por otro Usuario.");
					}
					console.log(error);
				})
		},
		rfidView(item){
			this.pinViewed = ({ 
				...item,
				...this.pinViewed
			});
			this.dialogRFID = true;
		},
		pinView(item){
			this.pinViewed = ({ 
				...item,
				...this.pinViewed
			});
			this.pin = true;
		},
		leerRFID(rfid){
			if ( this.$utils.strings.isOnlyNumbers(rfid) ){
				if ( this.rfidsLeidos.length < 3 ){
					if( this.rfidsLeidos.length === 0 ) {
						this.rfidsLeidos.push(rfid);
						this.percentRFID += 33;
					}
					else if ( this.rfidsLeidos.length === 1 ){
						if ( this.rfidsLeidos[0] == rfid ){
							this.rfidsLeidos.push(rfid);
							this.percentRFID += 33;
						}
					}
					else if ( this.rfidsLeidos.length === 2 ){
						if ( this.rfidsLeidos[1] == rfid ){
							this.rfidsLeidos.push(rfid);
							this.percentRFID += 34;
						}
					}
				}
			}
		},
		sugerirPin(){
			axios
			.get("/Personas/SugererPIN")
			.then(response => {
				this.pinViewed.pin = response.data;
			})
			.catch(error => {
				console.log(error);
			})
		},
		saveRFID(){
			this.pinViewed.pin = this.rfidsLeidos[0];
			this.savePINRFID();
		},
		initialize() {
			let me = this;
			me.getRoles();
			me.getTurnos();
			me.getComercialLineas();
			this.getOperadores();
			this.getPersonasMantenimiento();
			me.loading = true;
			axios
				.get("/Usuarios")
				.then((response) => {
          me.usuarios = response.data;
					me.loading = false;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getOperadores() {
			axios
				.get("/Personas")
				.then((response) => {
					this.personas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getPersonasMantenimiento(){
			axios
				.get("/Usuarios/PersonasMantenimientoUsuario")
				.then( response => {
					this.personasMantenimiento = response.data;
				})
				.catch(console.log)
		},
		getTurnos() {
			this.loadingTurnos = true;
			axios
				.get("/Turnos")
				.then((response) => {
					this.turnos = response.data;
					this.loadingTurnos = false;
				})
				.catch((error) => {
					this.loadingTurnos = false;
					console.log(error);
				});
		},
		getComercialLineas() {
			this.loadingLineas = true;
			axios
				.get("/ComercialLineas")
				.then((response) => {
					this.lineas = response.data;
					this.loadingLineas = false;
				})
				.catch((error) => {
					this.loadingLineas = false;
					console.log(error);
				});
		},
		getRoles() {
			let me = this;
			me.loadingRoles = true;
			axios
				.get("/Permisos/Roles")
				.then((response) => {
					me.roles = response.data;
					me.loadingRoles = false;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		editItem(item) {
      		this.action = 1;
			this.editedIndex = this.usuarios.indexOf(item);
			this.editedItem = Object.assign({}, item);
			const result = this.personasMantenimiento.find(persona => persona.idPersona == this.editedItem.idPersona);
			this.personasMantenimientoFiltred = !result 
				? [ 
					this.personas.find(persona => persona.idPersona == this.editedItem.idPersona),
					...this.personasMantenimiento
				]
				: this.personasMantenimiento.slice();
			this.dialog = true;
		},

		changeState(item) {
			let index = this.usuarios.indexOf(item);
			let me = this;
			this.usuarios[index].loading = true;
			if (!this.usuarios[index].condicion) {
				//Activar
				axios
					.put("/Usuarios/Activar/" + this.usuarios[index].idUsuario)
					.then((response) => {})
					.catch((error) => {
						console.log(error);
					});
			} else {
				axios
					.put(
						"/Usuarios/Desactivar/" + this.usuarios[index].idUsuario
					)
					.then((response) => {})
					.catch((error) => {
						console.log(error);
					});
			}
			this.usuarios[index].condicion = !this.usuarios[index].condicion;
		},
		close() {
			(this.action = 0), (this.dialog = false);
			setTimeout(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
				this.editedItem.idsTurnos = [];
				this.editedItem.idsComercialLineas = [];
				this.editedIndex = -1;
			}, 300);
		},
		validate() {
			const telefono = this.editedItem.telefono;
			this.errores = [];
			if (this.editedItem.idRol <= 0) {
				this.errores.push("* Debe de Seleccionar un Rol");
			}

			if(this.editedItem.idPersona == null){
				if (
					this.editedItem.nombre.length < 5 ||
					this.editedItem.nombre.length > 50
				) {
					this.errores.push(
						"* El Nombre debe tener más de 4 caracteres y menos de 50."
					);
				}
			}
			if (telefono) {
				if (!/^\d{10}$/.test(telefono)) {
					this.errores.push("* El Teléfono debe tener exactamente 10 dígitos numéricos.");
				}
			}
			if (
				this.editedItem.email.length < 5 ||
				this.editedItem.email.length > 50
			) {
				this.errores.push(
					"* El Email debe tener más de 4 caracteres y menos de 50."
				);
			}

			if (
				this.editedIndex < 0 &&
				(this.editedItem.password.length < 8 ||
					this.editedItem.password.length > 50)
			) {
				this.errores.push(
					"* La Contraseña debe tener más de 7 caracteres y menos de 50."
				);
			}
			return this.errores.length == 0;
		},
		resetPassword(){
			
			if(this.editedItem.idUsuario <= 0)
			return;
			else if (this.editedItem.idUsuario == null)
			return;

			axios
			.put("/Usuarios/RestablecerPassword/"+this.editedItem.idUsuario)
			.then(() => {
				this.dialogResetPassword = false;
				this.initialize();
				})
				.catch(() => {
					this.dialogResetPassword = false;					
				});
		},
		UnlockAccount(){
			
			if(this.editedItem.idUsuario <= 0)
			return;
			else if (this.editedItem.idUsuario == null)
			return;

			axios
			.put("/Usuarios/Desbloquear/"+this.editedItem.idUsuario)
			.then(() => {
				this.dialogUnloackAccount = false;
				
				this.initialize();
				})
				.catch(() => {
					me.dialogUnloackAccount = false;
					
				});
		},
		save() {
			this.action = 0;
			if (this.validate()) {
				let me = this;
				me.saving = true;
				if (this.editedIndex > -1) {
					//Código para editar
					axios
						.put(
							"/Usuarios/Actualizar/" +
								me.usuarios[me.editedIndex].idUsuario,
							{
								idRol: me.editedItem.idRol,
								nombre: me.editedItem.nombre || null,
								dobleFactor: me.editedItem.dobleFactor,
								idsTurnos: me.editedItem.idsTurnos,
                				idsComercialLineas: me.editedItem.idsComercialLineas,
								idPersona: this.editedItem.idPersona,
								telefono: me.editedItem.telefono || ""
							}
						)
						.then((response) => {
							me.saving = false;
							me.close();
							me.initialize();
						})
						.catch((error) => {
							me.saving = false;
							if (error.response) {
								if (error.response.status == 409) {
									me.alerta = true;
									me.errores.push(
										"Existe un Usuario con el mismo Email"
									);
								}
							}
						});
				} else {
					axios
						.post("/Usuarios/Crear", {
							idRol: me.editedItem.idRol,
							nombre: me.editedItem.nombre || null,
							email: me.editedItem.email,
							password: me.editedItem.password,
							dobleFactor: me.editedItem.dobleFactor,
							idsTurnos: me.editedItem.idsTurnos,
              				idsComercialLineas: me.editedItem.idsComercialLineas,
							idPersona: this.editedItem.idPersona,
							telefono: me.editedItem.telefono || ""
						})
						.then((response) => {
							me.saving = false;
							me.close();
							me.initialize();
						})
						.catch((error) => {
							me.saving = false;
							if (error.response) {
								if (error.response.status == 409) {
									me.alerta = true;
									me.errores.push(
										"Existe un Usuario con el mismo Email"
									);
								}
							}
						});
				}
			}
		},
	},
};
</script>

<style>
/* Borde sutil para el bloque de “última prueba” */
.border-light {
  border: 1px solid rgba(0,0,0,0.08);
}

/* Evita que el título y subtítulo se desborden */
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Citas del último mensaje con salto agradable */
.wrap-quotes {
  white-space: pre-line;
  word-break: break-word;
}

/* Avatar con leve fondo del brand */
.telegram-avatar {
  background: rgba(33, 150, 243, 0.08); /* azul leve */
}

/* Toques suaves */
.rounded-xl {
  border-radius: 14px;
}
.elevate {
  box-shadow: 0 6px 20px rgba(0,0,0,0.12) !important;
}
.status-chip { margin-top: 2px; } /* un poco de aire vertical si quieres */
/* Contorno suave del toggle */
.priority-toggle {
  border: 1px solid rgba(0,0,0,0.10);
  border-radius: 10px;
  padding: 2px;
}
.priority-btn { text-transform: none; font-weight: 600; }
.priority-btn:not(.white--text) { color:#5f6368 !important; background:#fff !important; }
.priority-btn .v-icon { margin-right: 6px; }

.chip-online  { background: #229ED9 !important; color: #fff !important; }
.chip-offline { background: #B0BEC5 !important; color: #fff !important; }
.chip-avatar  { background: rgba(255,255,255,.18); }

.tg-avatar{
  /* Degradado tipo Telegram */
  background: linear-gradient(180deg, #37AEE2 0%, #1E96C8 100%);
  /* opcional: sutil brillo */
  box-shadow: inset 0 0 0 1px rgba(255,255,255,.12);
  border-radius: 50%;
}
.tg-svg{ display:block; width:100%; height:100%; border-radius:50%; }
</style>